<template>
  <div class="container">
    <div>
      <md-field>
        <md-select
          :value="storeGroup"
          @input="$emit('update:storeGroup', $event)"
        >
          <md-option v-for="c in storeGroups" :key="c.code" :value="c.code">
            {{ c.name }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <gl-tree-view
      :entries="treeEntries"
      :selected="stores"
      v-on:update:selected="$emit('update:stores', $event)"
    >
      <template v-slot="_">
        <slot :vm="_.vm" :entry="_.entry">
          <div
            :title="
              _.entry.children && _.entry.children.length > 0
                ? ''
                : getDisplayEntryLabel(_.entry)
            "
          >
            {{ getDisplayEntryLabel(_.entry) }}
          </div>
        </slot>
      </template>
    </gl-tree-view>
  </div>
</template>

<script>
import GlTreeView from '@/components/common/GlTreeView.vue'
import ErrorReport from '@/mixins/ErrorReport'

/**
 * 店舗（任意複数）選択コンポーネント
 */
export default {
  components: { GlTreeView },
  mixins: [ErrorReport],
  props: {
    /**
     * 企業コード
     */
    company: {
      type: String,
    },
    /**
     * 選択している店舗グループ
     */
    storeGroup: {
      type: String,
    },
    /**
     * 選択している店舗
     */
    stores: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /**
       * 店舗グループマスタ
       */
      storeGroups: [],
      /**
       * 店舗ツリー描画用データ
       */
      treeEntries: [],
    }
  },
  watch: {
    company: {
      immediate: true,
      async handler(company, oldCompany) {
        if (company) {
          this.storeGroups = await this.$repositories
            .get('storeGroup')
            .get(this.company)

          if (!this.storeGroups || this.storeGroups.length === 0) {
            // 店舗グループが取得できない場合はもう続行不可
            throw new Error('店舗グループが取得できませんでした。')
          }

          //企業が変わってしまった場合も、初期値を選択してあげる
          if (
            (company != undefined &&
              oldCompany != undefined &&
              company != oldCompany) ||
            !this.storeGroup
          ) {
            // 店舗グループの選択は必須なので、初期で指定されていない場合は店舗グループ一覧の
            // 先頭を選んでいる状態で始める
            // こちらで自動設定したいので、Syncしている親コンポーネントに通知の必要があります
            this.$emit('update:storeGroup', this.storeGroups[0].code)
          }
        }
      },
    },
    // stores: {
    //   async handler(stores) {
    //     console.log('stores watch')
    //     console.log(stores.length)
    //   },
    // },
    storeGroup: {
      immediate: true,
      async handler(group) {
        if (group) {
          const storesTree = await this.$repositories
            .get('store')
            .get(group)
            .then(stores => [
              { code: undefined, name: '全店舗', children: stores, open: true },
            ])

          if (this.stores.length > 0) {
            const storesSet = new Set(this.stores)

            walk(storesTree[0], 0, entry => {
              if (entry.children) {
                return
              }
              entry.state = storesSet.has(entry.code) ? 'checked' : 'none'
            })
          }

          this.treeEntries = storesTree
        }
      },
    },
  },
  computed: {
    errors() {
      const errors = []

      if (!this.storeGroup) {
        errors.push('店舗グループを選択してください')
      }
      if (!this.stores || this.stores.length === 0) {
        errors.push('店舗を選択してください')
      }

      return errors
    },
  },
  methods: {
    /**
     * 表示ラベル取得
     *
     * 葉の場合のみコードも表示します。
     */
    getDisplayEntryLabel(entry) {
      if (entry.children && entry.children.length > 0) {
        return entry.name
      }
      // コードは `企業コード,店舗コード` のフォーマットなので、店舗コードだけにします
      const storeCode = entry.code
        .split(',')
        .slice(1)
        .join(',')
      return storeCode + '：' + entry.name
    },
  },
  async mounted() {},
}

/**
 * ツリーノードの再帰処理
 */
function walk(entry, level, f) {
  if (entry.children) {
    for (const child of entry.children) {
      walk(child, level + 1, f)
    }
  }
  f(entry, level)
}
</script>
